import { render, staticRenderFns } from "./NaviBar.vue?vue&type=template&id=fc56e5d4&"
import script from "./NaviBar.vue?vue&type=script&lang=js&"
export * from "./NaviBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports